import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import semver from "semver";
import { Container, Col, Button, Tooltip } from "reactstrap";
import { TimelineMax, TweenMax, Power0, Power2 } from "gsap";
import Tock from "tocktimer";
import { getCookie, saveCookie, removeCookie } from "~/utils/cookie";
import assetPath from "~/utils/assetPath";
import ModalComponent from "~/components/ModalComponent";
import {
  isProductionEnvironment,
  isDesktopApp,
  isReleased
} from "~/utils/misc";
import { countUp } from "~/utils/board";

// external-global styles must be imported in your JS.
import styles from "./styles.scss";

class PurchaseModalComponent extends React.Component {
  static propTypes = {
    onRef: PropTypes.func.isRequired
  };

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  constructor(props) {
    // Set props
    super(props);

    // Set initial state
    this.state = {
      isRestoreTooltopOpen: false
    };
  }

  componentWillMount() {
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidMount() {
    // Listen for Electron events
    if (isDesktopApp() && is.existy(window.electron)) {
      emitter.on("purchase_product_fetched", this.purchaseProductFetched);
    }
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  purchaseProductFetched = (product) => {
    const salePrice = product.price
    const formattedSalePrice = product.formattedPrice.replace(/[+-]?\d+([\.\,]\d+)?/g, salePrice)
    const price = _.round((_.ceil(salePrice) * 3) + salePrice, 2)
    const formattedPrice = product.formattedPrice.replace(/[+-]?\d+([\.\,]\d+)?/g, price)
    $(".purchase_modal_component .sale_price").text(`${product.formattedPrice}`);
    $(".purchase_modal_component .price").text(`${formattedPrice}`);
  }

  onShowModal = () => {
    $(".purchase_modal_component .modal-content").css("margin-bottom", "136px", "important");
  }

  showModal = () => {
    // Show modal
    this.purchaseModal.showModal();

    // Wait until render
    setTimeout(() => {
      // Show purchase if released Mac App Store version
      if (
        isDesktopApp() &&
        isReleased() &&
        is.truthy(bowser.mac)
      ) {
        // Change text
        $(".purchase_modal_component #purchase_container .checkmark_container .checkmark_one").text("Unlimited jigsaw plays");
        $(".purchase_modal_component #purchase_container .button_container .btn").html("Buy unlimited jigsaw plays for · <span class='strikethrough price'>$19.99</span> · <span class='sale_price'>$4.99</span>");
        $(".purchase_modal_component #sale_sticker p").text("75% OFF");

        // Set future date
        const futureDate = new Date();
        futureDate.setHours(futureDate.getHours() + 16);
        futureDate.setMinutes(futureDate.getMinutes() + 32);
        futureDate.setSeconds(futureDate.getSeconds() + 43);

        // Set date related fields
        if (is.future(new Date(getCookie("purchasePopoverFirstSeenDate", futureDate)))) {
          $(".purchase_modal_component #hero .title").html("Limited time offer · <span class='strikethrough price'>$19.99</span> · <span class='sale_price'>$4.99</span>");
          $(".purchase_modal_component #hero .subtitle").text(`Offer ends in ${countUp(futureDate.getTime() - new Date())}`);
          const countdown = new Tock({
            countdown: true,
            interval: 1000,
            callback: () => {
              $(".purchase_modal_component #hero .subtitle").text(`Offer ends in ${countUp(countdown.lap())}`);
            }
          });
          countdown.start(new Date(getCookie("purchasePopoverFirstSeenDate", futureDate)) - new Date())
        } else {
          $(".purchase_modal_component #hero .title").html("Unlimited jigsaw plays for only · <span class='strikethrough price'>$19.99</span> · <span class='sale_price'>$4.99</span>");
          $(".purchase_modal_component #hero .subtitle").html("Thousands of jigsaw puzzles included");
        }
      }

      // Animate hero
      TweenMax.to("#hero .hero_background_one", 3.2, {
        repeat: Infinity,
        ease: Power0.easeNone,
        top: "-=140",
        onComplete: () => {
          $("#hero .hero_background_one").css("top", 140)
        }
      });
      TweenMax.to("#hero .hero_background_two", 3.2, {
        repeat: Infinity,
        ease: Power0.easeNone,
        top: "-=140",
        onComplete: () => {
          $("#hero .hero_background_two").css("top", 140)
        }
      });

      // Animate sale tag
      TweenMax.to("#sale_sticker img", 12.8, {
        repeat: Infinity,
        ease: Power0.easeNone,
        rotation: -360
      });
    }, 0);

    // Get product
    if (isDesktopApp() && is.existy(window.electron) && is.existy(window.electron.fetchProduct) && isReleased()) {
      window.electron.fetchProduct(window.queryParameters.purchase_id);
    }

    // Track event
    mixpanel.track("Purchase modal shown");
  };

  handleFreeGameTap = () => {
    emitter.emit("freeGameRequested");
    mixpanel.track("Purchase modal free game tapped");
    this.purchaseModal.hideModal(true);
  };

  handlePurchaseTap = (type) => {
    // Purchase product
    if (isDesktopApp() && is.existy(window.electron)) {
      window.electron.purchaseProduct(window.queryParameters.purchase_id, type);
    }

    // Track event
    if (is.equal(type, "restore")) {
      mixpanel.track("Purchase modal restore tapped");
    } else {
      mixpanel.track("Purchase modal purchase tapped");
    }
  };

  toggleRestoreTooltip = () => {
    this.setState({
      isRestoreTooltopOpen: !this.state.isRestoreTooltopOpen
    });
  }

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <ModalComponent
        className="purchase_modal_component"
        onRef={ref => {
          this.purchaseModal = ref;
        }}
        toggleable={false}
        onShowModal={this.onShowModal}
      >
        <div id="hero">
          <div className="hero_background hero_background_one" style={{
            backgroundImage: `url(${assetPath("purchase_hero", "jpg")})`
          }}/>
          <div className="hero_background hero_background_two" style={{
            backgroundImage: `url(${assetPath("purchase_hero", "jpg")})`
          }}/>
          <h1 className="title">Support the developer for only <span className="sale_price">$4.99</span></h1>
          <h1 className="subtitle">Thousands of jigsaw puzzles included</h1>
        </div>
        <div id="sale_sticker">
          <img src={assetPath("sale_sticker", "png")} width="124" height="124" alt="Sale sticker" />
          <p><span className="sale_price">$4.99</span></p>
        </div>
        <Container>
          <div className="section_container" id="purchase_container">
            <Col>
              <div className="inner_container">
                <div className="checkmark_container">
                  <p className="checkmark_one">Remove popup</p>
                  <p>Thousands of jigsaw puzzles</p>
                  <p>Get unlimited jigsaw plays</p>
                  <p>All future versions of Jigsaw Puzzle</p>
                </div>
                <div className="button_container">
                  <Button
                    className="btn-lg"
                    color="primary"
                    onClick={this.handlePurchaseTap.bind(this, "purchase")}
                  >
                    Support the developer for only <span className="sale_price">$4.99</span>
                  </Button>
                  <p className="info">
                    <span id="restore_tooltip" className="restore_purchase" onClick={this.handlePurchaseTap.bind(this, "restore")}>Restore purchase</span><span> if you've bought before.</span>
                    <Tooltip placement="top" isOpen={this.state.isRestoreTooltopOpen} target="restore_tooltip" toggle={this.toggleRestoreTooltip}>
                      You will NOT be charged again if you've bought the app before. Even though it might say so in Apple's popup.
                    </Tooltip>
                  </p>
                </div>
              </div>
            </Col>
          </div>
        </Container>
        <div className="section_container" id="free_game_container">
          <div className="inner_container">
            <p className="info">Click below to play another free puzzle.</p>
            <div className="button_container">
              <div className="free_game_button_container">
                <Button
                  className="btn-lg"
                  color="secondary"
                  onClick={this.handleFreeGameTap}
                >
                  Play another free puzzle
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ModalComponent>
    );
  }
}

export default withStyles(styles)(PurchaseModalComponent);



// WEBPACK FOOTER //
// ./src/components/PurchaseModalComponent/index.js